import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.detailSymtom.loading;
export const detailSymtomErrorMessage = (state: RootState) =>
  state.detailSymtom.error;
export const detailSymtomDataResponse = (state: RootState) =>
  state.detailSymtom.detailSymtomResponse;
